(function () {
    const t = document.createElement("link").relList;
    if (t && t.supports && t.supports("modulepreload")) return;
    for (const r of document.querySelectorAll('link[rel="modulepreload"]'))
        s(r);
    new MutationObserver((r) => {
        for (const e of r)
            if (e.type === "childList")
                for (const f of e.addedNodes)
                    f.tagName === "LINK" && f.rel === "modulepreload" && s(f);
    }).observe(document, { childList: !0, subtree: !0 });
    function i(r) {
        const e = {};
        return (
            r.integrity && (e.integrity = r.integrity),
            r.referrerPolicy && (e.referrerPolicy = r.referrerPolicy),
            r.crossOrigin === "use-credentials"
                ? (e.credentials = "include")
                : r.crossOrigin === "anonymous"
                  ? (e.credentials = "omit")
                  : (e.credentials = "same-origin"),
            e
        );
    }
    function s(r) {
        if (r.ep) return;
        r.ep = !0;
        const e = i(r);
        fetch(r.href, e);
    }
})();
const T = DEFAULT_STICKERS,
    z = [
        1.08, 0.93, 1, 0.94, 1.07, 1.03, 0.96, 1, 1.12, 0.9, 0.93, 1.07, 1.02,
        1.07, 0.97,
    ],
    N = [
        [0, "rotate(-6deg)", 0.15],
        [7, "translate(3px, 2px) rotate(5deg)", 0.41],
        [12, "translate(-2px, 3px) rotate(-3deg)", 0.644],
        [1, "translate(2px, -2px) rotate(6deg)", 0.855],
        [9, "translate(-3px, 0) rotate(-4deg)", 1.045],
        [3, "translate(2px, 2px) rotate(4deg)", 1.216],
        [14, "translate(-2px, -1px) rotate(-5deg)", 1.37],
        [2, "translate(1px, 3px) rotate(3deg)", 1.508],
        [10, "translate(-1px, -2px) rotate(-3deg)", 1.633],
        [5, "rotate(2deg)", 1.745],
    ],
    D = [4, 6, 8, 11, 13, 7, 12, 9],
    C = {
        stickers: T,
        fit: z,
        pile: N,
        extra: D,
        background: "#2F3D94",
        maxSize: 320,
        mobileVw: 55,
        burstAt: 2350,
        mobileBreakpoint: 640,
        mobileBurstSlowdown: 1.4,
        skippable: !0,
        oncePerSession: !1,
        sessionKey: "ah-loader-played",
        preloadTimeout: 4e3,
        zIndex: 2000006,
        container: null,
    },
    A = (n, t) => {
        const i = Math.sin(n * 12.9898 + t * 78.233) * 43758.5453;
        return i - Math.floor(i);
    };
function O(n, t) {
    const i = [],
        s = n.length + t.length,
        r = 360 / s;
    for (let e = 0; e < s; e++) {
        const f = (e * 7) % s,
            c = e < n.length;
        i.push({
            pile: c,
            img: c ? n[e][0] : t[e - n.length],
            rest: c
                ? n[e][1]
                : `rotate(${(e % 2 ? 1 : -1) * (4 + ((e * 7) % 9))}deg)`,
            delay: c ? n[e][2] : 0,
            angle: f * r + (A(e, 1) - 0.5) * 26,
            spin: (e % 2 ? 1 : -1) * (12 + A(e, 2) * 70),
            reach: 0.95 + A(e, 3) * 0.35,
            dur: 0.72 + A(e, 4) * 0.26,
            lag: A(e, 5) * 0.07,
        });
    }
    return i;
}
function q(n, t) {
    const i = n.map(
        (s) =>
            new Promise((r) => {
                const e = new Image();
                ((e.onload = e.onerror = () => r()),
                    (e.src = s),
                    e.decode && e.decode().then(r, r));
            }),
    );
    return Promise.race([Promise.all(i), new Promise((s) => setTimeout(s, t))]);
}
function K(n = {}) {
    const t = { ...C, ...n },
        i = t.container || document.body;
    if (t.oncePerSession)
        try {
            if (sessionStorage.getItem(t.sessionKey)) return Promise.resolve();
            sessionStorage.setItem(t.sessionKey, "1");
        } catch {}
    const s =
            typeof matchMedia == "function" &&
            matchMedia("(prefers-reduced-motion: reduce)").matches,
        r = document.createElement("div");
    ((r.className = "ahl"),
        r.setAttribute("aria-hidden", "true"),
        (r.style.zIndex = t.zIndex));
    const e = document.createElement("div");
    ((e.className = "ahl-bg"), (e.style.background = t.background));
    const f = document.createElement("div");
    f.className = "ahl-stage";
    const c = document.createElement("div");
    c.className = "ahl-squeeze";
    const x = document.createElement("div");
    ((x.className = "ahl-pile"),
        x.style.setProperty(
            "--ahl-size",
            `min(${t.maxSize}px, ${t.mobileVw}vw)`,
        ));
    const b = O(t.pile, t.extra).map((l) => {
        const d = document.createElement("div");
        ((d.className = "ahl-fly"), (d.style.zIndex = l.pile ? "2" : "1"));
        const g = document.createElement("div");
        ((g.className = "ahl-rest"),
            (g.style.transform = `${l.rest} scale(${t.fit[l.img] ?? 1})`));
        const p = document.createElement("img");
        return (
            (p.className = "ahl-sticker"),
            (p.alt = ""),
            (p.decoding = "async"),
            (p.src = t.stickers[l.img]),
            (p.style.opacity = "0"),
            g.appendChild(p),
            d.appendChild(g),
            x.appendChild(d),
            { ...l, fly: d, img: p }
        );
    });
    (c.appendChild(x), f.appendChild(c), r.append(e, f), i.appendChild(r));
    document.documentElement.classList.remove("show-loader");
    const L = [],
        v = (l, d) => L.push(setTimeout(l, d));
    let F = 0;
    return new Promise((l) => {
        let d = !1;
        const g = () => {
            d ||
                ((d = !0),
                L.forEach(clearTimeout),
                cancelAnimationFrame(F),
                r.remove(),
                l());
        };
        q(t.stickers, t.preloadTimeout).then(() => {
            if (s) {
                (b.forEach((o) => {
                    o.pile && (o.img.style.opacity = "1");
                }),
                    r
                        .animate([{ opacity: 1 }, { opacity: 0 }], {
                            duration: 400,
                            delay: 500,
                            fill: "forwards",
                        })
                        .finished.then(g));
                return;
            }
            const I = performance.now();
            (b.forEach((o) => {
                o.pile &&
                    ((o.img.style.opacity = ""),
                    o.img.animate(
                        [
                            {
                                opacity: 0,
                                transform: "scale(1.3)",
                                filter: "drop-shadow(0 22px 18px rgba(10,16,60,.32))",
                                offset: 0,
                            },
                            { opacity: 1, offset: 0.03 },
                            {
                                opacity: 1,
                                transform: "none",
                                filter: "drop-shadow(0 1.5px 1.5px rgba(10,16,60,.3))",
                                offset: 1,
                            },
                        ],
                        {
                            duration: 220,
                            delay: o.delay * 1e3,
                            easing: "cubic-bezier(.55,0,1,.45)",
                            fill: "both",
                        },
                    ),
                    x.animate(
                        [
                            { transform: "none" },
                            {
                                transform: "translateY(3px) scale(.992)",
                                offset: 0.4,
                            },
                            { transform: "none" },
                        ],
                        { duration: 110, delay: o.delay * 1e3 + 220 - 20 },
                    ));
            }),
                b.forEach((o) => {
                    o.pile ||
                        (o.img.style.filter =
                            "drop-shadow(0 1.5px 1.5px rgba(10,16,60,.3))");
                }));
            let E = !1;
            const P = () => {
                if (E) return;
                ((E = !0),
                    performance.now() - I < t.burstAt &&
                        b.forEach((a) =>
                            a.img.getAnimations().forEach((m) => m.finish()),
                        ),
                    c.getAnimations().forEach((a) => a.cancel()));
                const w = window.innerWidth || 1280,
                    y = window.innerHeight || 800,
                    S = Math.sqrt(w * w + y * y) / 2 + 200,
                    h = S / 0.75,
                    u = w < t.mobileBreakpoint ? t.mobileBurstSlowdown : 1;
                (b.forEach((a) => {
                    a.img.style.opacity = "1";
                    const m = (a.angle * Math.PI) / 180;
                    (a.fly.animate(
                        [
                            { transform: "none" },
                            {
                                transform: `translate(${(Math.cos(m) * h * a.reach).toFixed(0)}px, ${(Math.sin(m) * h * a.reach).toFixed(0)}px) rotate(${a.spin.toFixed(0)}deg)`,
                            },
                        ],
                        {
                            duration: a.dur * 1e3 * u,
                            delay: a.lag * 1e3 * u,
                            easing: "cubic-bezier(0.25, 1, 0.5, 1)",
                            fill: "forwards",
                        },
                    ),
                        a.fly.animate([{ opacity: 1 }, { opacity: 0 }], {
                            duration: 250,
                            delay: 650 * u,
                            fill: "forwards",
                        }));
                }),
                    p(S, u),
                    v(g, 950 * u));
            };
            (v(() => {
                c.animate(
                    [{ transform: "none" }, { transform: "scale(.92)" }],
                    {
                        duration: 140,
                        easing: "cubic-bezier(.5,0,.75,0)",
                        fill: "forwards",
                    },
                );
            }, t.burstAt - 140),
                v(P, t.burstAt),
                t.skippable &&
                    r.addEventListener("pointerdown", P, { once: !0 }));
        });
        function p(I, E) {
            const P = 40 * E,
                o = 850 * E,
                w = (h) => 1 - Math.pow(1 - h, 4);
            let y = null;
            const S = (h) => {
                y === null && (y = h);
                const u = Math.max(0, Math.min(1, (h - y - P) / o)),
                    a = I * w(u),
                    m = (k) => `${Math.max(0, a + k).toFixed(1)}px`,
                    $ = `radial-gradient(circle at 50% 50%, transparent ${m(-180)}, rgba(0,0,0,0.12) ${m(-110)}, rgba(0,0,0,0.45) ${m(-40)}, rgba(0,0,0,0.82) ${m(30)}, #000 ${m(80)})`;
                ((e.style.webkitMaskImage = $),
                    (e.style.maskImage = $),
                    (e.style.opacity = (1 - u).toFixed(3)),
                    u < 1 && (F = requestAnimationFrame(S)));
            };
            F = requestAnimationFrame(S);
        }
    });
}
const M = "ah-loader-seen";
const TTL = 24 * 60 * 60 * 1000; // 1 day

function U() {
    try {
        const t = Number(localStorage.getItem(M));
        return t > 0 && Date.now() - t < TTL;
    } catch {
        return false;
    }
}
function R() {
    try {
        localStorage.setItem(M, String(Date.now()));
    } catch {}
}
function _(n = {}) {
    return U() ? Promise.resolve() : (R(), K(n));
}
_().then(() => {});
